import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Page } from '../../components';
import FormField from './fields/FormField';
import api from '../../utils/services';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      formId: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
};
const defaultProps = {
  user: null,
};

class ViewForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
    };
  }

  componentDidMount() {
    const { match: { params: { formId } } } = this.props;
    api.getFormById(formId)
      .then((data) => {
        this.setState({ form: data });
      });
  }

  render() {
    const { match: { params: { formId }, url: matchUrl }, user } = this.props;
    const { form: { formElements } } = this.state;

    const formFields = (formElements || []).map(formElement => (
      <FormField
        key={formElement.id}
        id={formElement.id}
        name={formElement.name}
        type={formElement.uiComponent}
      />
    ));

    const emptyMessage = 'This form has no elements.';

    return (
      <Page
        title={`Viewing form: ${formId}`}
        primaryAction={user ? { content: 'Edit', href: `${matchUrl}/edit` } : undefined}
      >
        <form>
          {formElements && formElements.length === 0 ? emptyMessage : formFields}
        </form>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}
ViewForm.propTypes = propTypes;
ViewForm.defaultProps = defaultProps;
export default connect(mapStateToProps)(ViewForm);
